import {
  SET_REJECTED_FILTERS,
  SET_CURRENT_SELECTED_REJECTED,
  SET_CURRENT_REJECTED_DETAILS,
  SET_REJECTED_GRID_SORT_CRITERIA,
  SET_REJECTED_PAGINATION,
  RESET_REJECTED_FILTERS,
} from './actionTypes';

export const setRejectedFilters = filters => ({
  type: SET_REJECTED_FILTERS,
  filters,
});

export const cleanRejectedFilters = () => ({
  type: RESET_REJECTED_FILTERS,
});

export const setCurrentSelectedRejected = rejected => ({
  type: SET_CURRENT_SELECTED_REJECTED,
  rejected,
});

export const setCurrentRejectedsDetails = details => ({
  type: SET_CURRENT_REJECTED_DETAILS,
  details,
});

export const setGridSortCriteria = sortCriteria => ({
  type: SET_REJECTED_GRID_SORT_CRITERIA,
  sortCriteria,
});

export const setRejectedPagination = pagination => ({
  type: SET_REJECTED_PAGINATION,
  pagination,
});
